import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
export class ConditionsOrderedOption extends ConditionRegistryCategory {
    label = 'Antwortoption';
    constructor(parent) {
        super(parent);
        super.init();
    }
    orderedoption_hasFailedToSelectInAtLeastOneStep = () => new ConditionRegistryItem({
        parent: this,
        label: 'Zu viele Fehlversuche - wäre richtig gewesen',
        eval: ({ orderedOption }) => !!orderedOption && orderedOption.optionUI.hasFailedToSelectInAtLeastOneStep,
    });
    orderedoption_correctOption = () => new ConditionRegistryItem({
        parent: this,
        label: 'Korrekte Option bei einem completed step',
        eval: ({ orderedOption, orderedTask }) => !!orderedTask.orderedTaskSteps.completedSteps.find(step => step.correctOption === orderedOption),
    });
    orderedoption_disappear = () => new ConditionRegistryItem({
        parent: this,
        label: 'Verschwindet: Korrekte Option bei einem completed step UND nie korrekte Option bei einem Remaining Step',
        eval: ({ orderedOption, orderedTask }) => !!orderedTask.orderedTaskSteps.completedSteps.find(step => step.correctOption === orderedOption) &&
            !orderedTask.orderedTaskSteps.remainingSteps.find(step => step.correctOption === orderedOption),
    });
    orderedoption_hideBecauseOfFailed = () => new ConditionRegistryItem({
        parent: this,
        label: 'Verstecke während Antwort aufgrund von Fehler',
        eval: ({ orderedOption }) => !!orderedOption && orderedOption.optionUI.shouldHideBecauseOfFailed,
    });
    orderedoption_shouldShowTemporaryFalseFeedback_1500ms = () => new ConditionRegistryItem({
        parent: this,
        label: 'Option: Should show temporary False feedback 1500ms',
        eval: ({ orderedOption }) => !!orderedOption && orderedOption.optionUI.shouldShowTemporaryFalseFeedback_1500ms,
    });
    orderedoption_shouldShowTemporaryCorrectFeedback_500ms = () => new ConditionRegistryItem({
        parent: this,
        label: 'Option: Should show temporary Correct feedback 500ms',
        eval: ({ app, orderedOption }) => {
            if (!orderedOption)
                return false;
            return orderedOption.optionUI.shouldShowTemporaryCorrectFeedback_500ms;
        },
    });
}
